var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_647_4597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6651 13.9966V12.6636C10.6651 11.9565 10.3842 11.2784 9.88425 10.7784C9.38427 10.2784 8.70615 9.99756 7.99907 9.99756H4.00002C3.29294 9.99756 2.61483 10.2784 2.11485 10.7784C1.61487 11.2784 1.33398 11.9565 1.33398 12.6636V13.9966",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6642 2.08472C11.2359 2.23293 11.7422 2.56678 12.1036 3.03387C12.4651 3.50096 12.6612 4.07484 12.6612 4.66544C12.6612 5.25604 12.4651 5.82992 12.1036 6.29701C11.7422 6.7641 11.2359 7.09795 10.6642 7.24616",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6636 13.9966V12.6636C14.6631 12.0729 14.4665 11.4991 14.1046 11.0322C13.7427 10.5654 13.236 10.2319 12.6641 10.0842",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 7.33158C7.47243 7.33158 8.66606 6.13796 8.66606 4.66555C8.66606 3.19314 7.47243 1.99951 6.00002 1.99951C4.52761 1.99951 3.33398 3.19314 3.33398 4.66555C3.33398 6.13796 4.52761 7.33158 6.00002 7.33158Z",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_647_4597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9962,
    height: 15.9962,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.5b7819e0477ba51686bcdb3b3c86d960.svg";
export { ForwardRef as ReactComponent };